"use client";
import React from "react";
import { lockScroll } from "../utilities/scroll/index.js";
const useScrollLock = (options) => {
    const { containerRef, originRef } = options || {};
    const [locked, setLocked] = React.useState(false);
    const unlockScrollRef = React.useRef(null);
    const handleLockScroll = React.useCallback(() => {
        unlockScrollRef.current = lockScroll({
            containerEl: containerRef?.current,
            originEl: originRef?.current,
            cb: () => setLocked(true),
        });
    }, [containerRef, originRef]);
    const handleUnlockScroll = React.useCallback(() => {
        unlockScrollRef.current?.(() => setLocked(false));
        unlockScrollRef.current = null;
    }, []);
    return React.useMemo(() => ({
        scrollLocked: locked,
        lockScroll: handleLockScroll,
        unlockScroll: handleUnlockScroll,
    }), [locked, handleLockScroll, handleUnlockScroll]);
};
export default useScrollLock;
